import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ValidateService {

  constructor(
  ) { }

  public validatesToString(validateObj: any): string {
    if (!validateObj) {
      return '';
    }

    if (typeof validateObj === 'string') {
      return validateObj;
    }

    console.log(Object.keys(validateObj));
    let msgs = '';
    for (const field of Object.keys(validateObj)) {
      if (typeof validateObj[field] === 'string') {
        msgs += validateObj[field] + '<br/>';
        continue;
      }

      for (const msg of validateObj[field]) {
        msgs += msg + '<br/>';
      }
    }

    return msgs;
  }
}
